<template>
    <div class="full-screen">
        <div>重新定向...</div>
    </div>
</template>

<script>
export default {
    name: 'redirect-users', // 將名稱與路由一致
    data() {
        return {
            case: this.$route.params.case || '', // 預設空字串
            token: this.$route.params.token || '', // 預設空字串
            userData:null
        };
    },
    watch: {
        // 監聽路由變化
        '$route.params': {
            handler(newParams) {
                this.case = newParams.case;
                this.token = newParams.token;
                this.handleRedirection(); // 在這裡執行您的重定向邏輯
            },
            immediate: true // 初次掛載時也會觸發
        }
    },
    methods: {
        decodeToken() {
            try {
                // 解碼 URL 編碼的 token
                const decodedToken = decodeURIComponent(this.token);
                // Base64 解碼
                const base64Decoded = this.atobUnicode(decodedToken);
                // 將解碼的 token 打印出來
                console.log('解碼後的 token:', base64Decoded);
                return base64Decoded;
            } catch (error) {
                console.error('解碼 token 時出錯:', error);
                return null;
            }
        },
        atobUnicode(str) {
            const base64Decoded = atob(str);
            return decodeURIComponent(base64Decoded.split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        },
        async loginHandle(){
            this.userData = this.decodeToken()
            this.userData = JSON.parse(this.userData)
            if ( 
                this.userData === null || 
                this.userData.code === undefined || 
                this.userData.code != 0 
            ){
                alert('登入失敗')
                console.log('userData:',this.userData)
                return
            }
            let res = this.userData
            console.log(res)
            if ( 
                process.env.VUE_APP_TEST_ENV == 'community' ||
                process.env.VUE_APP_TEST_ENV == 'table'
            ){

                this.$user.saveCommunityUserLogin(res) //使用者的紀錄資訊
                this.$router.push(`/train/index`)
                return
            }

            this.$user.saveUserLogin(res) //使用者的紀錄資訊
            //判斷是否購買過
            let formData = new FormData();
            formData.append('email', res.email);
            formData.append('app_name', 'brainrich');
            let status = await this.$api.get_detection_status(formData)
            console.log("status:",status)
            this.$router.push(`/train/index`)
            // 執行重定向的邏輯，比如發送請求或路由跳轉
        },
        paymentHandle(){
            const res = this.decodeToken()
            console.log('paymentHandle=',res)
            this.$router.push('/main')
        },
        async handleRedirection() {
            console.log('重定向進行中...');
            console.log('Case:', this.case);
            console.log('Token:', this.token);
            //Case為login時處理
            if ( this.case == 'login' ){
                this.loginHandle()
                return
            }
            if ( this.case == 'logout' ){
                localStorage.clear()
                this.$shared.initLocalStorageData()
                this.$router.push(`/main`)
                return
            }
            if ( this.case == 'payment' ){
                this.paymentHandle()
            }
            //Case
        }
    },
    mounted() {
        this.handleRedirection(); // 組件掛載後立即處理重定向
    },
};
</script>

<style scoped>
.full-screen {
    padding-top: 10dvh;
    padding-bottom: 10dvh;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f0f0f0;
}
</style>
